import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; operations_modules: number; task_types: number;
  provider_interfaces: number; background_jobs: number; quality_gates: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; tasks_executable: boolean; workflow_engine_operational: boolean;
  approvals_operational: boolean; automation_rules_operational: boolean;
  escalations_operational: boolean; execution_history_complete: boolean;
  audit_complete: boolean; gaps?: string[];
};

export type Aow001Status = {
  sprint_id: string; objectives: number; operations_modules: number; task_types: number;
  autonomous_operations: boolean; workflow_engine: boolean; approval_engine: boolean;
  automation_rules: boolean; execution_history: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const autonomousOpsAow001Api = {
  dashboard: () => fetchG<SprintDashboard>('/aow001/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/aow001/objectives').then((r) => r.objectives),
  operationsModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/aow001/operations-modules').then((r) => r.modules),
  taskTypes: () => fetchG<{ task_types: { key: string; name: string; category: string }[] }>('/aow001/task-types').then((r) => r.task_types),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/aow001/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/aow001/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/aow001/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/aow001/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Aow001Status>('/aow001/status'),
};
